export default __webpack_public_path__ + "static/media/zodiacToto-Monkey.2213c274.png";